<template>
  <div>
    <generic-table
      ref="datatable"
      :title="$t('sirc credit information cases')"
      :columns="columns"
      :column_search="true"
      resource_url="/sirc-credit-information/case/datatables"
    >
      <template v-slot:buttons>
        <button class="button is-secondary is-rounded" @click="bulk_process">
          <span class="icon"><i class="fa fa-list"></i></span>
          <span>{{ $t("bulk process") }}</span>
        </button>
        <button class="button is-secondary is-rounded" @click="create">
          <span class="icon"><i class="fa fa-plus"></i></span>
          <span>{{ $t("add") }}</span>
        </button>
      </template>
    </generic-table>
    <details-modal ref="details_modal" />
    <case-modal ref="case_modal" @success="refresh" />
    <bulk-modal ref="bulk_modal" @success="success_bulk" />
  </div>
</template>

<script>
// import GenericTable from "../../../../app/src/components/generic_table/GenericTable.vue";
import GenericTable from "@/components/generic_table/GenericTable.vue";
import {
  generate_datatables_buttons,
  confirm_deletion_dialog,
  del,
  put,
  download,
  get,
  error_message,
  success_message,
  format_currency,
} from "@/utils";
import CaseModal from "./case_modal/Index.vue";
import BulkModal from "./bulk_modal/Index.vue";
import DetailsModal from "./details_modal/Index.vue";
import moment from "moment";

export default {
  name: "FactoringsDatatable",
  components: { GenericTable, CaseModal, DetailsModal, BulkModal },
  data() {
    let v = this;
    return {
      columns: [
        {
          title: v.$t("name"),
          name: "name",
          searchable: true,
          data: (row) => {
            return row.name || "";
          },
        },
        {
          title: v.$t("dpi"),
          name: "settings.dpi",
          searchable: true,
          data: (row) => {
            return row.dpi || "";
          },
        },
        {
          title: v.$t("nit"),
          name: "settings.nit",
          searchable: true,
          data: (row) => {
            return row.nit || "";
          },
        },
        {
          title: v.$t("info"),
          searchable: false,
          data: (row) => {
            let r = "";

            let execution_icon = `<span class="icon has-text-warning"><i class="fa fa-clock-o"></i>`;
            if (row.is_sirc_executed) {
              execution_icon = `<span class="icon has-text-success"><i class="fa fa-check"></i>`;
            }
            r += `<span class="tag">
                      ${execution_icon}
                      </span> <span>${v.$t("execute sirc")}</span>
                    </span>`;

            if (row.has_been_errors) {
              r += `<span class="tag is-danger" data-tooltip="${v.$t(
                "see details for further information"
              )}">
                      <span class="icon"><i class="fa fa-exclamation-triangle"></i>
                      </span> <span>${v.$t("has errors")}</span>
                    </span>`;
            }

            return r;
          },
        },
        // {
        //   title: v.$t("data"),
        //   name: "name",
        //   searchable: true,
        //   width: "70%",
        //   data: (row) => {
        //     return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
        //     // return row.name || "";
        //   },
        // },
        {
          title: v.$t("options"),
          width: "20%",
          searchable: false,
          data: (row) => {
            let btns = [
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("execute sirc"),
                icon: "fa fa-angle-right",
                icon_class: "is-small has-text-primary",
                click: (e) => {
                  let uuid = e.detail.uuid;
                  put("/sirc-credit-information/case/execute", { uuid: uuid })
                    .then(() => {
                      v.refresh();
                    })
                    .catch((error) => {
                      error_message(error);
                    });
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("details"),
                icon: "fa fa-eye",
                icon_class: "is-small",
                click: function (e) {
                  // console.log("edit order", e.detail.uuid);
                  v.$refs.details_modal.show_modal(e.detail.uuid);
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("delete"),
                icon: "fa fa-trash",
                icon_class: "is-small has-text-danger",
                click: (e) => {
                  let uuid = e.detail.uuid;
                  confirm_deletion_dialog(
                    v.$t(
                      "are you sure to delete sirc credit information case?"
                    ),
                    v,
                    () => {
                      del("/sirc-credit-information/case", { uuid: uuid })
                        .then(() => {
                          v.refresh();
                        })
                        .catch((error) => {
                          error_message(error);
                        });
                    }
                  );
                },
              },
            ];

            return generate_datatables_buttons(btns);
          },
        },
      ],
    };
  },
  methods: {
    create() {
      let v = this;
      v.$refs.case_modal.show_modal();
    },
    bulk_process() {
      let v = this;
      v.$refs.bulk_modal.show_modal();
    },
    refresh() {
      let v = this;
      v.$refs.datatable.refresh();
    },
    success_bulk() {
      let v = this;
      v.refresh();
      success_message(v.$t("bulk process has started"));
    },
  },
  mounted() {
    this.refresh();
  },
};
</script>

<style></style>
